import styled from 'styled-components'

interface IChatStyledProps {}

export const ChatStyled = styled.div<IChatStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
